// src/pages/About.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { FaBullseye, FaBolt, FaLock, FaHandshake, FaMobileAlt } from 'react-icons/fa';
import './About.css';

export default function About() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <img className="about-hero-image" src="/images/about-local-providers.png" alt="" />
        <div className="about-hero-content">
          <p className="about-eyebrow">Local connections. More possibilities.</p>
          <h1 className="about-title">About SnapConX</h1>
          <p className="about-subtitle">
            Connecting people with local services and products, when they need them.
          </p>
        </div>
      </section>

      {/* Main Content */}
      <div className="about-container">
        {/* Mission Statement */}
        <section className="about-section mission-section">
          <div className="section-icon">
            <FaBullseye />
          </div>
          <h2>Our Mission</h2>
          <p>
            SnapConX connects people with local businesses, making it easier to book services and order and pay for products in one app.
          </p>
        </section>

        {/* Features Grid */}
        <section className="features-section">
          <h2 className="section-title">What Makes Us Different</h2>
          <div className="features-grid">
            <div className="feature-box">
              <div className="feature-icon">
                <FaBolt />
              </div>
              <h3>Lightning Fast</h3>
              <p>Book appointments in seconds with our intuitive platform.</p>
            </div>
            <div className="feature-box">
              <div className="feature-icon">
                <FaLock />
              </div>
              <h3>Secure Payments</h3>
              <p>Your transactions are protected with bank-level security.</p>
            </div>
            <div className="feature-box">
              <div className="feature-icon">
                <FaHandshake />
              </div>
              <h3>Trusted Network</h3>
              <p>All service providers are verified and rated by real users.</p>
            </div>
            <div className="feature-box">
              <div className="feature-icon">
                <FaMobileAlt />
              </div>
              <h3>Mobile Ready</h3>
              <p>Manage everything on the go with our mobile-friendly platform.</p>
            </div>
          </div>
        </section>

        {/* Values Section */}
        <section className="values-section">
          <h2 className="section-title">Our Core Values</h2>
          <div className="values-grid">
            <div className="value-card">
              <h4>Innovation</h4>
              <p>Constantly improving to serve you better</p>
            </div>
            <div className="value-card">
              <h4>Transparency</h4>
              <p>Clear communication and honest practices</p>
            </div>
            <div className="value-card">
              <h4>Community</h4>
              <p>Building connections that matter</p>
            </div>
            <div className="value-card">
              <h4>Excellence</h4>
              <p>Quality service in everything we do</p>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <section className="stats-section">
          <div className="stat-box">
            <div className="stat-number">10K+</div>
            <div className="stat-label">Active Users</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">500+</div>
            <div className="stat-label">Service Providers</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">50K+</div>
            <div className="stat-label">Bookings Made</div>
          </div>
          <div className="stat-box">
            <div className="stat-number">4.8★</div>
            <div className="stat-label">Average Rating</div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="about-cta">
          <h2>Ready to Get Started?</h2>
          <p>Join thousands of satisfied users and service providers today.</p>
          <Link className="about-start-link" to="/guide">Get Started Now</Link>
        </section>
      </div>
    </div>
  );
}
